import {
  AggregationType,
  GetDeviceDataKPIsResponse,
  GetDeviceDataTelemetryResponse,
} from '../gen/proto/api/gateway/v1/gateway_pb';
import { gatewayClient } from './api-grpc';
import { Timestamp } from '@bufbuild/protobuf/wkt';

export const telemetryApi = {
  async getDeviceTopicList(uuid: string): Promise<string[]> {
    const response = await gatewayClient.getDeviceTopicList({
      deviceUuid: uuid,
    });

    if (!response.topics) {
      throw new Error('Retrieve device topic list failed: no topics returned.');
    }

    return response.topics;
  },

  async getDeviceDataTelemetry(
    uuid: string,
    topic: string,
    startTime: Timestamp,
    endTime: Timestamp,
    pageIndex: number,
    pageSize: number,
    aggregation: AggregationType,
    intervalSeconds: bigint,
  ): Promise<GetDeviceDataTelemetryResponse> {
    return await gatewayClient.getDeviceDataTelemetry({
      deviceUuid: uuid,
      topic: topic,
      pagination: {
        pageIndex: pageIndex,
        pageSize: pageSize,
      },
      startTime: startTime,
      endTime: endTime,
      aggregation: aggregation,
      intervalSeconds: intervalSeconds,
      ascending: false,
    });
  },

  async getDeviceKPI(
    uuid: string,
    topic: string,
    startTime: Timestamp,
    endTime: Timestamp,
  ): Promise<GetDeviceDataKPIsResponse> {
    return await gatewayClient.getDeviceDataKPIs({
      deviceUuid: uuid,
      topic: topic,
      startTime: startTime,
      endTime: endTime,
    });
  },
};
